/** @format */

export const LCP_EVENT_NAME = 'LCP_READY';
export const LCP_STABILITY_TIMEOUT_MS = 1000;
